import React from "react";
import { Flex } from "@chakra-ui/react";
import { reportToolbarStyles } from "../Styles/reportToolbarStyles";

export function ReportToolbar({ children, ...props }) {
  return <Flex {...reportToolbarStyles.toolbar} {...props}>{children}</Flex>;
}
